import { render } from "./Media.vue?vue&type=template&id=0a1db930"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"

import "./Media.vue?vue&type=style&index=0&id=0a1db930&lang=scss"
script.render = render

export default script